// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true, es6:true*/
(function(){
if (typeof module=='object' && module.exports)
    require('regenerator-runtime/runtime');
const define = typeof module!='object' || !module.exports ? self.define
    : require('../../../util/require_node.js').define(module, '..');
define(['/www/lum/pub/plans_lw.js', '/util/ajax.js', '/util/etask.js',
    '/util/date.js', '/util/string.js', 'lodash4'],
    (zplans_lw, ajax, etask, date, string, _)=>
{
const {qw} = string;
const {assign} = Object;
const E = assign({}, zplans_lw);

const sec = {hours: date.sec.HOUR, days: date.sec.DAY};

E.is_changed = (new_plan, cur_plan, opt)=>{
    opt = opt||{};
    if (!new_plan)
        return false;
    if (!cur_plan)
        return true;
    for (const type of ['type', 'dc_light', 'dc_unlim'])
    {
        if (new_plan[type]!=cur_plan[type])
            return true;
    }
    if (cur_plan && cur_plan.disable=='noperm' && opt.is_resident)
        return true;
    if (cur_plan && cur_plan.disable=='noalloc')
        return true;
    let n_plan = E.clean(_.cloneDeep(new_plan));
    let c_plan = E.clean(_.cloneDeep(cur_plan||{}), {keep_cost: true});
    let keys_cost = ['base_cost', 'cost', 'precommit'];
    if (!_.isEqual(_.pick(n_plan, keys_cost), _.pick(c_plan, keys_cost)))
        return true;
    if (!!n_plan.lock_zone!=!!c_plan.lock_zone)
        return true;
    if (new_plan.type=='resident'||new_plan.type=='unblocker')
    {
        let keys_res = qw('city asn vip vips mobile domain_whitelist '
            +'vip_country vips_type port_ranges unblocker ssl '
            +'vip_country_city socks5 state async_mode serp linkedin '
            +'google_search_ads google_search_ads_beta remove_personal_data '
            +'brightbot target_tier automated_unblocking default_country '
            +'cache_mode zip ub_premium ub_browser mobile_new long_session '
            +'cust_head solve_captcha_disable smart_resi browsers_enabled '
            +'custom_expect');
        return !_.isEqual(_.pick(n_plan, keys_res), _.pick(c_plan, keys_res));
    }
    if (new_plan.type=='static')
    {
        let new_ips = +new_plan.ips|0;
        let current_ips = +(cur_plan||{}).ips|0;
        let keys_st = qw('ips_type ip_alloc_preset port_ranges '
            +'domain_whitelist exclusive_sec country not_country country_city '
            +'exclusive_num exclusive_type bandwidth subnet_distribution '
            +'city vendor socks5 ip_fallback include_ranges exclude_ranges '
            +'cache_mode default_country '
            +'subpool'+(opt.check_geo_db ? ' geo_db' : ''));
        return new_ips!=current_ips ||
            !_.isEqual(_.pick(n_plan, keys_st), _.pick(c_plan, keys_st)) ||
            n_plan.pool_ip_type!=c_plan.pool_ip_type;
    }
    if (new_plan.type=='browser_api')
    {
        let keys_res = ['cust_head', 'solve_captcha_disable', 'ub_premium'];
        return !_.isEqual(_.pick(n_plan, keys_res), _.pick(c_plan, keys_res));
    }
};

// -- normalisation & validation --
// XXX: merge this with zone.js normalisation/validation fn

const sanitize = p=>{
    p = E.clean(E.prepare(_.cloneDeep(p)));
    E.sanitize_plan_dw(p);
    return p;
};

E.clean = (plan, opt)=>{
    opt = opt||{};
    let net = E.get_plan_network(plan);
    let blacklist = {};
    let no_falsey = {mobile: 1, unblocker: 1, vip: 1, city: 1, asn: 1, serp: 1,
        state: 1, socks5: 1, ssl: 1, async_mode: 1, cache_mode: 1,
        long_session: 1, smart_resi: 1};
    if ({dc: 1, res_static: 1, dc_light: 1,
        dc_unlim: 1, res_static_unlim: 1}[net])
    {
        let has_ips = +!(plan.ips_type=='shared'&&plan.ip_alloc_preset);
        if (has_ips)
            plan.ips = plan.ips||0;
        else
        {
            assign(blacklist, {ips: 1, country: 1, not_country: 1,
                country_city: 1});
        }
        if (plan.ips_type=='shared')
            assign(blacklist, {exclusive_sec: 1});
        if (plan.ips_type!='selective')
            assign(blacklist, {domain_whitelist: 1});
        plan.geo_db = _.pickBy(plan.geo_db, Boolean);
        if (!_.some(plan.geo_db)||_.isEqual(_.keys(plan.geo_db), ['maxmind']))
            delete plan.geo_db;
    }
    else
    {
        assign(blacklist, {ips_type: 1, ips: 1, exclusive_sec: 1,
            country: 1, not_country: 1, country_city: 1});
    }
    if ({res_rotating: 1, mobile: 1, unblocker: 1, serp: 1}[net])
    {
        plan.vip = +!!(plan.vips_type && plan.vips_type!='shared');
        if (plan.vip)
            plan.vips = plan.vips||0;
        else
        {
            assign(blacklist, {vip: 1, vips_type: 1, vips: 1,
                vip_country: 1, vip_country_type: 1, vip_country_city: 1});
        }
        if (plan.vips_type=='shared' || plan.vips_type=='vip')
            assign(blacklist, {domain_whitelist: 1});
    }
    else
    {
        assign(blacklist, {vip: 1, vips_type: 1, vips: 1, asn: 1, state: 1,
            vip_country: 1, vip_not_country: 1, vip_country_city: 1});
    }
    if (net=='unblocker')
    {
        plan.linkedin = +!!plan.linkedin;
        plan.ub_browser = +!!plan.ub_browser;
    }
    else
        assign(blacklist, {linkedin: 1, ub_browser: 1});
    if (net=='unblocker' || net=='browser_api')
        plan.ub_premium = +!!plan.ub_premium;
    else
        blacklist.ub_premium = 1;
    if (net=='unblocker' || net=='serp' || net=='browser_api')
        plan.cust_head = +!!plan.cust_head;
    else
        blacklist.cust_head = 1;
    if (net=='unblocker')
        plan.custom_expect = +!!plan.custom_expect;
    else
        blacklist.custom_expect = 1;
    if (blacklist.exclusive_sec)
        assign(blacklist, {exclusive_type: 1, exclusive_num: 1});
    Object.keys(plan).forEach(k=>{
        let v = plan[k];
        if (v==null || v==='' || blacklist[k] || !v&&no_falsey[k])
            delete plan[k];
        else if (v=='any' && /^(ip_|vip_|default_)?country(_city)?$/.test(k))
            delete plan[k];
    });
    if (plan.type && !plan.is_custom)
    {
        if (!opt.keep_cost && plan.cost!=null)
            delete plan.cost;
        if (!opt.keep_cost && plan.precommit!=null)
            delete plan.precommit;
    }
    return plan;
};

E.clean_plan = plan=>{
    if (plan.domain_whitelist && plan.domain_whitelist.length)
    {
        let domains = plan.domain_whitelist.split(/\s+/);
        domains = _.compact(domains);
        if (!_.every(domains, E.is_domain))
            throw new Error('Wrong whitelist domains');
        plan.domain_whitelist = domains.join(' ');
    }
    if ((plan.type=='static' && plan.ips_type=='selective'
        || plan.type=='resident' && plan.vip && plan.vips_type=='domain')
        && !plan.domain_whitelist.length)
    {
        throw new Error('Add at least one target domain');
    }
    if (plan.type=='static' && !plan.country || plan.type=='resident'
        && plan.vip && !plan.vip_country && plan.vip_country_type=='specific')
    {
        throw new Error('Select a country');
    }
    if (plan.type=='static' && plan.country!='any' && plan.city)
    {
        let countries = qw(plan.country);
        let cities = qw(plan.country_city);
        if (!countries.every(c=>cities.some(cc=>cc.startsWith(c))))
            throw new Error('A city must be selected');
    }
    if (plan.type=='static' && plan.ips_type!='shared')
        plan.exclusive_sec = +plan.exclusive_num*sec[plan.exclusive_type];
    if (plan.type=='static' && plan.ips_type=='shared' &&
        ['shared_block', 'shared_res_block', 'shared_res_pool',
            'shared_dc_pool'].includes(plan.ip_alloc_preset))
    {
        delete plan.ips;
    }
    if (plan.type=='resident' && plan.vips_type=='shared')
        delete plan.vips;
    return plan;
};

E.prepare = (plan, opt)=>{
    plan = plan||E.create_default_plan();
    opt = opt||{};
    if (opt.convert_to_custom && E.is_plan_custom(plan))
        plan.is_custom = true;
    // res features
    plan.mobile = !!plan.mobile;
    plan.city = !!plan.city;
    plan.asn = !!plan.asn;
    plan.state = !!plan.state;
    ['unblocker', 'ssl', 'socks5', 'serp', 'cache_mode', 'smart_resi']
    .forEach(k=>{
        plan[k] = +!!plan[k];
        if (!plan[k])
            delete plan[k];
    });
    // gIP basics
    plan.vip = !!plan.vip;
    // XXX vladislavl: domain_p and domain types are same on UI side
    plan.vips_type = plan.vips_type=='domain_p'&&'domain' || plan.vips_type
        || 'shared';
    plan.vips = +plan.vips|0;
    // IP basics
    plan.ips_type = plan.ips_type||'shared';
    plan.ips = +plan.ips|0;
    // IP/gIP allocation parameters
    plan.domain_whitelist = plan.domain_whitelist||'';
    plan.country = plan.country||'any';
    plan.not_country = plan.not_country||'';
    plan.vip_country = plan.vip_country||'any';
    plan.country_city = plan.country_city||'';
    plan.vip_country_city = plan.vip_country_city||'';
    plan.exclusive_sec = +plan.exclusive_sec|0;
    if (!plan.exclusive_type || plan.exclusive_num==null)
    {
        plan.exclusive_type = plan.exclusive_sec%sec.days ? 'hours' : 'days';
        plan.exclusive_num = plan.exclusive_sec / sec[plan.exclusive_type]|0;
    }
    // pricing
    if (plan.type=='static' && !plan.pool_ip_type)
        plan.bandwidth = plan.bandwidth||'payperusage';
    return plan;
};

E.sanitize_plan_dw = plan=>{
    let dw = plan&&plan.domain_whitelist;
    if (!dw)
        return;
    plan.domain_whitelist = Array.isArray(dw) ?
        dw.map(v=>(''+v).toLowerCase()) : (''+dw).toLowerCase();
};

E.is_domain = domain=>{
    let re = /^(?:\w(?:[\w-+]{0,61}\w)?\.)+\w[\w-]{0,61}\w$/;
    return domain.match(re);
};

E.validate_port_ranges = port_ranges=>{
    let t = 'spotify|bin|http|https|http_connect|smtp';
    let port_range_rx = '((\\d+)(-(\\d+))?|any)(:('+t+')(:([\\w\\.-]+))?)?';
    return !port_ranges || new RegExp('^'+port_range_rx
        +'(,'+port_range_rx+')*$').test(port_ranges);
};

// -- plan creation & edit --

E.create_split_plan = (src, start)=>{
    let split_pl = _.cloneDeep(src);
    split_pl.start = date(start, true);
    for (let ipk of ['ips', 'vips'])
    {
        if (split_pl[ipk]>0)
            split_pl[ipk+'_new'] = 0;
        else if (split_pl[ipk+'_new']!=null)
            delete split_pl[ipk+'_new'];
        if (split_pl[ipk+'_new_refresh']!=null)
            delete split_pl[ipk+'_new_refresh'];
    }
    return split_pl;
};

E.create_default_plan = (cust, opt)=>{
    opt = opt||{};
    cust = cust||{name: 'fake'};
    let net = opt.network||'dc';
    if (!default_plans[net])
        throw new Error('Unsupported network: '+net);
    let start = date(opt.start || opt.stub&&cust.start, 1);
    let plan = assign({start: start}, default_plans[net]);
    if (!opt.enabled)
        plan.disable = 1;
    if (opt.stub)
        plan.stub = 1;
    plan.product = zplans_lw.get_plan_product(plan);
    return plan;
};

const default_plans = {
    dc: {type: 'static', ip_alloc_preset: 'shared_block',
        ips_type: 'shared', bandwidth: 'payperusage', ip_fallback: 1},
    dc_light: {type: 'static', ip_alloc_preset: 'shared_lite', 'dc_light': 1,
        ips_type: 'shared', bandwidth: 'payperusage'},
    dc_unlim: {type: 'static', ips_type: 'shared', bandwidth: 'unlimited',
        ip_fallback: 1, unl_bw_tiers: 'cn', ips: 1},
    dc_freemium: {type: 'static', ips_type: 'shared', bandwidth: 'payperusage',
        ip_fallback: 1, ip_alloc_preset: 'shared_fremium'},
    'dc.skip_pmethod': {type: 'static', ip_alloc_preset: 'skip_pmethod',
        ips_type: 'shared', bandwidth: 'payperusage', ip_fallback: 1},
    res_static: {type: 'static', pool_ip_type: 'static_res',
        ips_type: 'shared', ips: 1},
    res_static_unlim: {type: 'static', pool_ip_type: 'static_res',
        ips_type: 'shared_ppu', unl_bw_pkg: {type: 'd_1'}, ips: 1},
    res_rotating: {type: 'resident', vips_type: 'shared', city: 1},
    mobile: {type: 'resident', mobile: 1, vips_type: 'shared', city: 1},
    serp: {type: 'unblocker', serp: 1, vips_type: 'shared'},
    unblocker: {type: 'unblocker', unblocker: 1, vips_type: 'shared'},
    scraping_shield: {type: 'bright_shield', scraping: 1},
    assets_shield: {type: 'bright_shield', assets: 1},
    cache_dump: {type: 'cache_dump'},
    // XXX davidg: WIP
    browser_api: {type: 'browser_api'},
};

// -- ip/vip allocation --

E.domain_whitelist_compare = (new_plan, cur_plan)=>{
    let old_dmn = _.uniq((cur_plan.domain_whitelist||'').split(' '));
    let new_dmn = _.uniq((new_plan.domain_whitelist||'').split(' '));
    let old_dmn_set = new Set(old_dmn), new_dmn_set = new Set(new_dmn);
    let add = new_dmn.filter(h=>!old_dmn_set.has(h));
    let rm = old_dmn.filter(h=>!new_dmn_set.has(h));
    return {add, rm};
};

E.should_refresh_static_ips = (new_plan, cur_plan, opt)=>{
    opt = opt||{};
    if (!cur_plan || cur_plan.type!='static' || !cur_plan.ips)
        return false;
    if (new_plan.type!='static' || opt.no_reserve ||
        opt.removed_ips && opt.removed_ips==cur_plan.ips)
    {
        return true;
    }
    new_plan = sanitize(new_plan);
    cur_plan = sanitize(cur_plan);
    let cmp = k=>cur_plan[k]!=new_plan[k]&&(cur_plan[k]||new_plan[k]);
    let is_added_geo = k=>{
        let old_v = (cur_plan[k]||'').split(' ');
        let new_v = (new_plan[k]||'').split(' ');
        return !!_.difference(new_v, old_v).length;
    };
    let is_any_cn = !cur_plan.country && !cur_plan.not_country;
    let is_any_city = !cur_plan.country_city;
    let changed = qw('type ips_type exclusive_sec ip_alloc_preset '
        +'pool_ip_type').some(cmp) ||
        is_any_cn&&is_added_geo('country') ||
        is_any_city&&is_added_geo('country_city') ||
        !_.isEqual(new_plan.geo_db, cur_plan.geo_db) ||
        !_.isEqual(new_plan.vendor, cur_plan.vendor) ||
        cur_plan.not_country && new_plan.country ||
        !_.isEqual(new_plan.subpool, cur_plan.subpool);
    return changed;
};

E.should_refresh_vips = (new_plan, cur_plan, opt)=>{
    opt = opt||{};
    if (!cur_plan || cur_plan.type!='resident' || !cur_plan.vips)
        return false;
    if (new_plan.type!='resident' || opt.removed_vips==cur_plan.vips)
        return true;
    let cmp = k=>cur_plan[k]!=new_plan[k]&&(cur_plan[k]||new_plan[k]);
    let changed = qw('type vip vips_type domain_whitelist alloc_preset mobile')
        .some(cmp) || !cur_plan.vip_country&&new_plan.vip_country ||
        !cur_plan.vip_country_city&&new_plan.vip_country_city;
    return changed;
};

E.removed_static_ips_geo = (...args)=>removed_ips_geo_fn(['country_city',
    'country', 'not_country'], ...args);

E.removed_vips_geo = (...args)=>removed_ips_geo_fn(['vip_country_city',
    'vip_country'], ...args);

const removed_ips_geo_fn = (fields, new_plan, cur_plan)=>{
    let removed_geo = (k, p1, p2)=>{
        let old_v = ((p1||cur_plan)[k]||'').split(' ');
        let new_v = ((p2||new_plan)[k]||'').split(' ');
        let l = _.difference(old_v, new_v);
        return l.length && l;
    };
    for (let i=0; i<fields.length; i++)
    {
        let r = removed_geo(fields[i]);
        if (r)
            return r;
    }
};

E.removed_static_ips_count = (cust, zid, new_plan, cur_plan, geo_stats_fn)=>{
    let has_geo = geo=>!!new_plan[geo] && new_plan[geo]!='any';
    if (!cur_plan || cur_plan.type!='static' || !cur_plan.ips ||
        new_plan.type!='static' ||
        !has_geo('country')&&!has_geo('not_country')&&!has_geo('country_city'))
    {
        return 0;
    }
    let aff_geo = E.removed_static_ips_geo(new_plan, cur_plan);
    return aff_geo ? removed_ips_count(cust, zid, aff_geo, geo_stats_fn,
        '/users/zone/alloc_geo_stats') : 0;
};

E.removed_vips_count = (cust, zid, new_plan, cur_plan, geo_stats_fn)=>{
    if (!cur_plan || cur_plan.type!='resident' || !cur_plan.vip ||
        new_plan.type!='resident' || !new_plan.vip_country ||
        new_plan.vip_country=='any')
    {
        return;
    }
    let aff_geo = E.removed_vips_geo(new_plan, cur_plan);
    return aff_geo && removed_ips_count(cust, zid, aff_geo, geo_stats_fn,
        '/users/zone/alloc_vips_geo_stats');
};

const removed_ips_count = (cust, zid, aff_geo, stats_fn, stats_url)=>etask(
function*(){
    this.on('uncaught', e=>console.error(e));
    let res = stats_fn ? yield stats_fn()
        : ajax.get(stats_url, {qs: {zone: zid, customer_id: cust.id}});
    let stats = res.geo_stats||res;
    return aff_geo.map(geo=>_.get(stats, geo, 0)).reduce((c1, c2)=>c1+c2);
});

// -- geo data --

E.get_domain_status = domains=>etask(function*(){
    this.on('uncaught', e=>console.error(e));
    let res = yield ajax.get('/users/zone/domain_status',
        {data: {domains: (domains||[]).join(',')}});
    return res||{};
});

E.countries = {
    load: ()=>{
        if (E.countries.set)
            return E.countries.set;
        if (E.countries.et)
            return E.countries.et;
        // use 'cancel: false' to not allow react to stop the process
        return E.countries.et = etask({cancel: false}, function*(){
            this.on('uncaught', e=>console.error(e));
            let res = yield ajax.get('/users/zone/countries');
            if (!res)
                return;
            return E.countries.set = res;
        });
    },
};

E.google_countries = {
    load: ()=>{
        if (E.google_countries.set)
            return E.google_countries.set;
        if (E.google_countries.et)
            return E.google_countries.et;
        return E.google_countries.et = etask({cancel: false}, function*(){
            this.on('uncaught', e=>console.error(e));
            let res = yield ajax.get('/users/zone/google_countries');
            if (!res)
                return;
            return E.google_countries.set = res;
        });
    },
};

E.shared_block_countries = ()=>etask(function*(){
    this.on('uncaught', e=>console.error(e));
    let res = yield ajax.get('/users/zone/shared_block_countries');
    return res||[];
});

E.static_subpools = {
    load: cust=>{
        let cname = cust && cust.name;
        let cache = E.static_subpools._cache = E.static_subpools._cache||{};
        cache[cname] = cache[cname]||{};
        return cache[cname].et = cache[cname].et || etask(function*(){
            this.on('uncaught', e=>console.error(e));
            let res = yield ajax.get('/users/zone/subpools', {qs:
                {customer_id: cust.id}});
            return cache[cname].set = res;
        });
    },
    get: cust=>{
        let cname = cust && cust.name;
        let cache = E.static_subpools._cache||{};
        return (cache[cname]||{}).set||[];
    },
};

// XXX vladislavl: possible union with 'countries' for dc
E.vip_countries = {
    load: ()=>{
        if (E.vip_countries.set)
            return E.vip_countries.set;
        if (E.vip_countries.et)
            return E.vip_countries.et;
        return E.vip_countries.et = etask({cancel: false}, function*(){
            this.on('uncaught', e=>console.error(e));
            let res = yield ajax.get('/users/zone/vip_countries');
            if (!res)
                return;
            return E.vip_countries.set = res;
        });
    },
};

E.vip_cities = {
    load: ()=>{
        if (E.vip_cities.set)
            return E.vip_cities.set;
        if (E.vip_cities.et)
            return E.vip_cities.et;
        return E.vip_cities.et = etask({cancel: false}, function*(){
            this.on('uncaught', e=>console.error(e));
            let res = yield ajax.get('/users/zone/vip_cities');
            if (!res)
                return;
            return E.vip_cities.set = res;
        });
    },
};

E.vip_country_region_cities = {
    load: ()=>{
        if (E.vip_country_region_cities.set)
            return E.vip_country_region_cities.set;
        if (E.vip_country_region_cities.et)
            return E.vip_country_region_cities.et;
        return E.vip_country_region_cities.et = etask({cancel: false},
        function*(){
            this.on('uncaught', e=>console.error(e));
            let res = yield ajax.get('/users/zone/vip_country_region_cities');
            if (!res)
                return;
            for (let cn of Object.keys(res))
            {
                for (let r of Object.keys(res[cn]))
                    res[cn][r] = new Set(res[cn][r]);
            }
            return E.vip_country_region_cities.set = res;
        });
    },
};

E.cities = {
    load: provider=>{
        provider = provider||'';
        let cities = E.cities[provider] = E.cities[provider]||{};
        if (cities.set)
            return cities.set;
        if (cities.et)
            return cities.et;
        return cities.et = etask({cancel: false}, function*(){
            this.on('uncaught', e=>console.error(e));
            let res = yield ajax.get('/users/zone/cities',
                {qs: {provider: provider}});
            if (!res)
                return;
            return cities.set = res;
        });
    },
};

E.cities_map = {
    load: ()=>{
        let cities_map = E.cities_map;
        if (cities_map.set)
            return cities_map.set;
        if (cities_map.et)
            return cities_map.et;
        return cities_map.et = etask({cancel: false}, function*(){
            this.on('uncaught', e=>console.error(e));
            let res = yield ajax.json({url: '/users/zone/cities_map'});
            if (!res)
                return;
            return cities_map.set = res;
        });
    }
};

E.available_geo = {
    load: ()=>{
        if (E.available_geo.set)
            return E.available_geo.set;
        if (E.available_geo.et)
            return E.available_geo.et;
        return E.available_geo.et = etask({cancel: false}, function*(){
            this.on('uncaught', e=>console.error(e));
            let res = yield ajax.get('/users/zone/available_geo');
            if (!res)
                return;
            return E.available_geo.set = {
                dc: {country: res.dc.country||[], city: res.dc.city||[]},
                res: {country: res.res.country||[], city: res.res.city||[]},
            };
        });
    },
};

// XXX vladislavl: move to layer up because no plan specific
E.geo_db_list = {
    load: ()=>{
        if (E.geo_db_list.set)
            return E.geo_db_list.set;
        if (E.geo_db_list.et)
            return E.geo_db_list.et;
        return E.geo_db_list.et = etask({cancel: false}, function*(){
            this.on('uncaught', e=>console.error(e));
            let res = yield ajax.get('/users/zone/geo_db_list');
            if (!res)
                return;
            return E.geo_db_list.set = res;
        });
    },
};

E.premium_domains = {
    load: ()=>{
        if (E.premium_domains.set)
            return E.premium_domains.set;
        if (E.premium_domains.et)
            return E.premium_domains.et;
        return E.premium_domains.et = etask({cancel: false}, function*(){
            this.on('uncaught', e=>console.error(e));
            const res = yield ajax.get('/users/zone/premium_domains');
            if (!res)
                return [];
            return E.premium_domains.set = Object.keys(res.domains).sort();
        });
    },
};

E.dc_isp_unlim_start = date('2024-11-04T20:00:00.000Z');

return E; }); })(); // eslint-disable-line
